module.exports = __webpack_public_path__ + "img/shield.14c52a12.svg";